export default "__VITE_ASSET__etzjDjI3__"